module.exports = __webpack_public_path__ + "img/4.29b8deb4.jpg";